import React from 'react';
import { generateImageSource } from '../../utils/generateImageSource';
import HowItWorks from './HowItWorks';
import FindConstructionJobs from './FindConstructionJobs';
import PostJobsCard from './PostJobsCard';
import LandingBanner from './LandingBanner';

const SplashPage = () => {

  return (
    <div className="ptp-splash-page__container">
      <img
        className="splash-page-banner__mobile-header"
        alt="find-candidate"
        src={generateImageSource('/images/v1/path-to-pro/PathtoProLogo.svg')}
      />
      <LandingBanner />
      <div className="ptp-splash-page__cards-section">
        <PostJobsCard />
        <FindConstructionJobs />
      </div>
      <HowItWorks />
    </div>
  );
};

export default SplashPage;
